import React from "react";
import {observer} from "mobx-react-lite";
import {Button, Checkbox, Dropdown, Form, FormField, Grid, Segment} from "semantic-ui-react";
import eventTesterStore, {skladEntityTypes} from "./EventTesterStore";

function EventTester() {
    if (!eventTesterStore.visible) {
        return <></>
    }

    return <Grid>
        <Grid.Column width={'6'}>
            <Segment>
                <Form>
                    <FormField>
                        <label>StockTransferEventId</label>
                        <input value={eventTesterStore.stockTransferEventId}
                               onChange={e => eventTesterStore.setStockTransferEventId(e.target.value)}/>
                    </FormField>
                    <Button onClick={() => eventTesterStore.triggerStockTransferEventHandler()}
                            color={'teal'}>Trigger</Button>
                    <Checkbox label={'For Debug'} checked={eventTesterStore.forDebug}
                              onChange={(_, data) => eventTesterStore.changeForDebug(data.checked ?? false)}/>
                    <Button floated={'right'} onClick={() => eventTesterStore.hide()}>Close</Button>
                </Form>
            </Segment>
        </Grid.Column>
        <Grid.Column width={'6'}>
            <Segment>
                <Form>
                    <FormField>
                        <label>UserId</label>
                        <input value={eventTesterStore.skladEntityUserId}
                               onChange={e => eventTesterStore.setSkladEntityUserId(e.target.value)}/>
                    </FormField>
                    <FormField>
                        <label>Sklad EntityId (product, variant, bundle)</label>
                        <input value={eventTesterStore.skladEntityId}
                               onChange={e => eventTesterStore.setSkladEntityId(e.target.value)}/>
                    </FormField>
                    <FormField>
                        <label>EntityType</label>
                        <Dropdown selection options={skladEntityTypes} value={eventTesterStore.skladEntityType}
                                  onChange={(_, data) => eventTesterStore.setSkladEntityType(data.value as number)}/>
                    </FormField>
                    <Button onClick={() => eventTesterStore.triggerSkladEntityChangesProcessor()}
                            color={'teal'}>Trigger</Button>
                    <Checkbox label={'For Debug'} checked={eventTesterStore.forDebug}
                              onChange={(_, data) => eventTesterStore.changeForDebug(data.checked ?? false)}/>
                    <Button floated={'right'} onClick={() => eventTesterStore.hide()}>Close</Button>
                </Form>
            </Segment>
        </Grid.Column>
    </Grid>
}

export default observer(EventTester);